// ---------------------------------------------------------------------------
// Conditional novelty
// ---------------------------------------------------------------------------
var noveltyModules = noveltyModules || {};

// ノベルティの判定処理を行う関数
function checkNoveltyEligibility() {
  try {
    console.time('exec-time');

    // ノベルティコードのcartAttributeを初期化する
    noveltyModules.initCartAttributes();

    // URLよりデバッグモードを取得
    let url = new URL(window.location.href);
    let params = url.searchParams;
    let debugParam = params.get('debug_mode');
    console.log('debugParam: ' + debugParam);

    let noveltyList = JSON.parse(document.getElementById("noveltyList").textContent);
    if (noveltyList.length == 0) return false;

    // カート情報をcart.jsから取得
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart == null) return false;

        // 各キャンペーンの条件判定総件数
        var totalCount = new Object();
        totalCount['noveltyList'] = 0;

        // 各キャンペーンの非表示件数
        var hiddenCount = new Object();
        hiddenCount['noveltyList'] = 0;

        // 各キャンペーン条件判定
        for (let i = 0; i < noveltyList.length; i++) {
          if (!Object.keys(noveltyList[i]).length) continue;

          let data = noveltyList[i];
          let conditios = data.conditions;

          // 各キャンペーンの総件数カウントアップ
          totalCount['noveltyList'] += 1;

          console.log(data.handle + " is debugMode is " + data.debugMode);

          // 対象のキャンペーンがデバッグモードかどうか
          if (data.debugMode != 'true') {

            // キャンペーン期間判定
            if (noveltyModules.isNotCampaignPeriod(data.startDateTime, data.endDateTime)) { hiddenCount['noveltyList'] += 1; continue; }
            // キャンペーン条件設定無し
            if (Object.keys(conditios).length === 0) { hiddenCount['noveltyList'] += 1; continue; }
            // ノベルティの在庫が設定されてる、且つ在庫が無い
            if (data.inventoryQuantity != '' && data.inventoryQuantity == '0') { hiddenCount['noveltyList'] += 1; continue; }

          } else {

            // 対象のキャンペーンがデバッグモードで、URLのパラメータにdebugModeが付与されていない場合、表示隠す
            if (debugParam != 'true') {
              noveltyModules.hideElement(data.handle);
              hiddenCount['noveltyList'] += 1;
              continue;
            }
          }

          // 各条件ごとに満たしているかどうか判定
          let judgeResult = noveltyModules.judgeConditions(conditios, structuredClone(cart));
          console.log(data.handle + " is judge is " + judgeResult);

          // 条件を満たしているため、ラジオボタンを有効にする
          if (judgeResult === true) {
            noveltyModules.enableNnovelty(data.handle);
          } else {
            // 条件を満たしていないため、ラジオボタンを無効にする
            noveltyModules.disableNovelty(data.handle);
          }
        }

        // ラジオボタンのクリックイベントを設定
        noveltyModules.setupNoveltyRadioEvents();

        // 判定処理が完了したら、ノベルティエリアを表示する
        noveltyModules.setNoveltyAreaVisibility('novelty-list-area');

        console.log("totalCount: " + totalCount['noveltyList']);
        console.log("hiddenCount: " + hiddenCount['noveltyList']);

        // 注意書き表示/非表示制御
        if (totalCount['noveltyList'] === hiddenCount['noveltyList']) {
          if (document.getElementById('message_empty_novelty')) document.getElementById('message_empty_novelty').style.visibility = 'visible';
          noveltyModules.hideElement('message_caution');
        } else {
          if (document.getElementById('message_caution')) document.getElementById('message_caution').style.visibility = 'visible';
          noveltyModules.hideElement('message_empty_novelty');
        }

        console.timeEnd('exec-time')
    })
    .catch(error => {
      console.error('[Novelty] Error fetching cart:', error);
    });
  } catch (e) {
    console.log("[Exception occurred] " + e.stack);
  }
}

// --------------------
// DOMContentLoadedイベントリスナーで各ノベルティの判定を実行
// --------------------
window.addEventListener('DOMContentLoaded', function () {
  checkNoveltyEligibility();
});

// 選択されているラジオボタンを外す関数
noveltyModules.clearNoveltySelection = function() {
  // すべてのノベルティラジオボタンを取得
  const noveltyRadios = document.querySelectorAll('input[name="attributes[selectNovelty]"]');
  
  // 各ラジオボタンのチェックを外す
  noveltyRadios.forEach(radio => {
    radio.checked = false;
  });
};

// --------------------
// 数量変更時のノベルティの判定を再実行 by cart.js
// --------------------
noveltyModules.onCartQuantityUpdate = function() {
  console.log(`[Novelty] onCartQuantityUpdate関数が開始されました`);
  
  // 選択されているラジオボタンを外す
  noveltyModules.clearNoveltySelection();
  
  // カートの状態が更新されたら、ノベルティの判定を再実行
  checkNoveltyEligibility();
};

// --------------------
// ノベルティコードのcartAttributeを初期化する
// ※ノベルティコードを選択してチェックアウトに遷移してカート画面に戻ってくると値が残ったままとなる為
// --------------------
noveltyModules.initCartAttributes = function () {
  fetch('/cart/update.js', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      attributes: {
        'selectNovelty': ''
      }
    }),
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
  })
  .catch((error) => {
    console.error(error);
  });
};

// --------------------
// ラジオボタンのクリックイベントを設定
// --------------------
noveltyModules.setupNoveltyRadioEvents = function () {
  // すべてのノベルティラジオボタンを取得
  const noveltyRadios = document.querySelectorAll('input[name="attributes[selectNovelty]"]');
  // ノベルティを複数追加できるように洗濯中のノベルティを管理する変数
  let checked_novelties = '';
    
  // 各ラジオボタンにクリックイベントを設定
  noveltyRadios.forEach(radio => {
    // 無効化されているラジオボタンにはイベントをバインドしない
    if (radio.disabled) {
      return;
    }

    if(radio.checked) {
      if(checked_novelties == '') {
        checked_novelties = radio.value;
      } else {
        checked_novelties = `${checked_novelties},${radio.value}`;
      }
      console.log('checked_novelties:' + checked_novelties);
    }

    radio.addEventListener('change', function() {
      if (this.checked) {
        if(checked_novelties == '') {
          checked_novelties = this.value;
        } else {
          checked_novelties = `${checked_novelties},${this.value}`;
        }
        // 選択されたノベルティコードをcartAttributeに設定
        noveltyModules.updateNoveltySelection(checked_novelties);
      } else {
        // 選択されていないノベルティコードがある場合はcartAttributeから削除
        if(checked_novelties.match(`,${this.value}`)) {
          checked_novelties = checked_novelties.replace(`,${this.value}`, '');
        }
        if(checked_novelties.match(this.value)) {
          checked_novelties = checked_novelties.replace(this.value, '');
        }
        noveltyModules.updateNoveltySelection(checked_novelties);
      }
    });
  });

  noveltyModules.updateNoveltySelection(checked_novelties);
};

// --------------------
// 選択されたノベルティコードをcartAttributeに設定
// --------------------
noveltyModules.updateNoveltySelection = function (noveltyCode) {
  fetch('/cart/update.js', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      attributes: {
        'selectNovelty': noveltyCode
      }
    }),
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    console.log('ノベルティコードが更新されました: ' + noveltyCode);
  })
  .catch((error) => {
    console.error('ノベルティコードの更新に失敗しました:', error);
  });
};

// --------------------
// キャンペーン期間外判定
// --------------------
noveltyModules.isNotCampaignPeriod = function (start, end) {
  // 現在日時、開始日時、終了日時全ての日時を日本時間にして比較する
  let jstNow = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
  let jstStart = new Date(Number(start) * 1000 + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
  let jstEnd = new Date(Number(end) * 1000 + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));

  let nowDateTime = Math.floor(jstNow.getTime() / 1000);
  let startTime = Math.floor(jstStart.getTime() / 1000);
  let endTime = Math.floor(jstEnd.getTime() / 1000);

  if (nowDateTime < startTime || endTime < nowDateTime) {
    return true;
  }

  return false;
};

// --------------------
// 指定した要素を非表示
// --------------------
noveltyModules.hideElement = function (id, parentFlg=false) {
  let elm = '';
  if (parentFlg === true) {
    elm = document.getElementById(id).parentNode;
  } else {
    elm = document.getElementById(id);
  }
  if (elm) {
    elm.remove();
  }
};

// --------------------
// 指定したノベルティを選択可とする
// （Liquid で表示されていない場合は何もしない。例：在庫0以下でブロックが出力されていない）
// --------------------
noveltyModules.enableNnovelty = function (id) {
  let itemArea = document.getElementById(id);
  if (!itemArea) return;

  // アイテムエリアの表示可能デザインにする
  if (itemArea.classList.contains('not_applicable')) {
    itemArea.classList.remove('not_applicable');
  }

  // ラジオボタンを表示
  let radioArea = document.getElementById(id + '-radio-area');
  if (radioArea) {
    radioArea.style.display = "block";
  }

  // ラジオボタンを使用可能にする
  let radio = document.getElementById(id + '-radio');
  if (radio) {
    radio.disabled = false;
    if(radio.dataset.checked != null) {
      radio.checked = true;
    }
  }
};

// --------------------
// 指定したノベルティを無効化する関数
// --------------------
noveltyModules.disableNovelty = function(id) {
  // アイテムエリアの表示不可デザインにする
  let itemArea = document.getElementById(id);
  if (itemArea.classList.contains('not_applicable')) {
    return; // すでにnot_applicableクラスが存在する場合は処理をスキップ
  }
  itemArea.classList.add('not_applicable');

  // ラジオボタンを非表示 ※displayスタイルを削除する
  let radioArea = document.getElementById(id + '-radio-area');
  if (radioArea) {
    radioArea.style.removeProperty('display');
  }

  // ラジオボタンを使用不可にする
  let radio = document.getElementById(id + '-radio');
  if (radio) {
    radio.disabled = true;
    radio.checked = false;
  }
};

// --------------------
// ノベルティエリアの表示/非表示を設定
// --------------------
noveltyModules.setNoveltyAreaVisibility = function(id, visible = true) {
  const noveltyArea = document.getElementById(id);
  if (noveltyArea) {
    noveltyArea.style.visibility = visible ? 'visible' : 'hidden';
  }
};

// --------------------
// 各キャンペーン適用条件の判定
// --------------------
noveltyModules.judgeConditions = function (conditions, cart) {

  // 合計に含まない商品の金額と個数を取得
  let [excludePrice, excludeQuantity, excludeIndex] = noveltyModules.getPriceAndQuantityTotalExclude(conditions.totalExcludeProducts, conditions.totalExcludeProductsInCollection, cart);
//   console.log(excludePrice, excludeQuantity, excludeIndex);

  // 合計に含まない商品をカートから削除する（後ろから削除していく。前から削除するとINDEXが常時前詰めされてしまい、削除されないため）
  const reverseExcludeIndex = excludeIndex.reverse();
  reverseExcludeIndex.forEach((item) => {
    cart.items.splice(item, 1);
  });

  // 合計に含まない商品を除いたことで、カートが空になった場合、条件未達成としてfalseを返却
  if (cart.items.length === 0) {
    return false;
  }

  // 合計購入個数
  if (conditions.totalQuantity != '') {
    if (noveltyModules.judgeTotalQuantity(conditions.totalQuantity, excludeQuantity, cart) === false) return false;
  }

  // 合計金額
  if (conditions.totalAmount != '') {
    if (noveltyModules.judgeTotalAmount(conditions.totalAmount, excludePrice, cart) === false) return false;
  }

  // 対象コレクション
  if (conditions.targetCollection != '') {
    if (noveltyModules.judgeTargetCollection(conditions.targetCollection, cart) === false) return false;
  }

  // 対象コレクション２
  if (conditions.targetCollectionSecond != '') {
    if (noveltyModules.judgeTargetCollection(conditions.targetCollectionSecond, cart) === false) return false;
  }

  // 対象商品
  if (conditions.targetProducts != '') {
    if (noveltyModules.judgeTargetProducts(conditions.targetProducts, cart) === false) return false;
  }

  // 対象外とする文字列が商品名に含まれた商品がカートに存在するか
  if (conditions.notTargetStrings != '') {
    if (noveltyModules.judgeNotTargetStrings(conditions.notTargetStrings, cart) === false) return false;
  }

  // 対象外とする商品タイプが設定された商品がカートに存在するか
  if (conditions.notTargetProductTypeStrings != '') {
    if (noveltyModules.judgeNotTargetProductTypeStrings(conditions.notTargetProductTypeStrings, cart) === false) return false;
  }

  return true;
}

// ---------------------------------------------------------------------------
// 条件判定メソッド一覧
// ---------------------------------------------------------------------------

// ---------------------------------------------------------------------------
// 合計金額、購入個数に含まない商品の金額とカート内の個数を取得
// ---------------------------------------------------------------------------
noveltyModules.getPriceAndQuantityTotalExclude = function (excludeSkus, excludeProductIds, cart) {
  let excludePrice = 0;
  let excludeQuantity = 0;
  let excludeIndex = [];

  // 合計金額から除外する商品(SKU、又は商品ID)いずれも設定されていない場合、return
  if (excludeSkus.length == 0 && excludeProductIds.length == 0) {
    return [excludePrice, excludeQuantity, excludeIndex];
  }

  // 合計金額から除外する商品(SKU、又は商品ID)が設定されている場合、対象の金額、カート内の個数を取得
  for (let i = 0; i < cart.items.length; i++) {
    if (excludeSkus.includes(cart.items[i].sku)) {
      excludePrice += cart.items[i].original_line_price;
      excludeQuantity += cart.items[i].quantity;
      excludeIndex.push(i);
    } else if (excludeProductIds.includes(cart.items[i].product_id)) {
      excludePrice += cart.items[i].original_line_price;
      excludeQuantity += cart.items[i].quantity;
      excludeIndex.push(i);
    }
  }

  return [excludePrice, excludeQuantity, excludeIndex];
}

// ---------------------------------------------------------------------------
// 合計購入個数判定
// ---------------------------------------------------------------------------
noveltyModules.judgeTotalQuantity = function (value, excludeQuantity, cart) {
  // 合計金額から除外するSKUの個数を減算
  let calcItemCount = cart.item_count - excludeQuantity;

  if (calcItemCount >= value) {
    return true;
  }

  return false;
}

// ---------------------------------------------------------------------------
// 合計金額判定
// ---------------------------------------------------------------------------
noveltyModules.judgeTotalAmount = function (value, excludePrice, cart) {
  // 合計金額から除外するSKUの金額を減算
  let tmpPrice = cart.original_total_price - excludePrice;
  let calcTotalPrice = (tmpPrice / 100.0).toFixed();

  if (Number(calcTotalPrice) >= Number(value)) {
    return true;
  }

  return false;
}

// ---------------------------------------------------------------------------
// コレクション判定
// 概要：キャンペーン対象のコレクションに属する商品がカートに存在するか
// ---------------------------------------------------------------------------
noveltyModules.judgeTargetCollection = function (targetProductIds, cart) {
  let result = false;
  for (let i = 0; i < cart.items.length; i++) {
    if (targetProductIds.includes(cart.items[i].product_id)) {
      result = true;
      break;
    }
  }

  return result;
}

// ---------------------------------------------------------------------------
// 商品判定
// 概要：キャンペーン対象の商品（SKU）がカートに存在するか
// ---------------------------------------------------------------------------
noveltyModules.judgeTargetProducts = function (targetProductSkus, cart) {
  let result = false;
  for (let i = 0; i < cart.items.length; i++) {
    if (targetProductSkus.includes(cart.items[i].sku)) {
      result = true;
      break;
    }
  }

  return result;
}

// ---------------------------------------------------------------------------
// 対象外とする文字列が含まれている商品存在判定
// 概要：対象外とする文字列が商品名に含まれた商品がカートに存在するか
// ---------------------------------------------------------------------------
noveltyModules.judgeNotTargetStrings = function (notTargetStrings, cart) {
  // 対象外文字列いずれかにマッチする正規表現作成
  const regex = new RegExp(notTargetStrings.join('|'));

  let result = true;
  for (let i = 0; i < cart.items.length; i++) {
    if (regex.test(cart.items[i].product_title)) {
      result = false;
      break;
    }
  }

  return result;
}

// ---------------------------------------------------------------------------
// 対象外とする商品タイプが設定された商品判定
// 概要：対象外と商品タイプの商品がカートに存在するか
// ---------------------------------------------------------------------------
noveltyModules.judgeNotTargetProductTypeStrings = function (notTargetProductTypeStrings, cart) {
  let result = true;
  for (let i = 0; i < cart.items.length; i++) {
    if (notTargetProductTypeStrings.includes(cart.items[i].product_type)) {
      result = false;
      break;
    }
  }

  return result;
}
